import { useCallback, useState } from 'react';

/**
 * Shared product-detail open state for Our Menu.
 * `openIntent` is 'cart' | 'plan' | null (null when opened from image/title).
 * Edit mode seeds variant / add-on / quantity for an existing cart line.
 */
export function useOurMenuProductDetail() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [openIntent, setOpenIntent] = useState(null);
  const [editSession, setEditSession] = useState(null);

  const openProduct = useCallback((item, options) => {
    setSelectedItem(item);
    setOpenIntent(
      options?.intent === 'plan' || options?.intent === 'cart' ? options.intent : null,
    );
    if (options?.mode === 'edit' && options?.editCartKey) {
      const qtys =
        options.initialAddOnQtys && typeof options.initialAddOnQtys === 'object'
          ? options.initialAddOnQtys
          : null;
      setEditSession({
        editCartKey: String(options.editCartKey),
        initialVariantId:
          options.initialVariantId != null ? options.initialVariantId : null,
        initialAddOnIds: Array.isArray(options.initialAddOnIds)
          ? options.initialAddOnIds
          : [],
        initialAddOnQtys: qtys,
        initialQuantity: Math.max(1, Math.round(Number(options.initialQuantity) || 1)),
      });
    } else {
      setEditSession(null);
    }
  }, []);

  const closeProduct = useCallback(() => {
    setSelectedItem(null);
    setOpenIntent(null);
    setEditSession(null);
  }, []);

  return {
    selectedItem,
    openIntent,
    editSession,
    openProduct,
    closeProduct,
  };
}
